import { useI18n } from "vue-i18n";
import { format, OptionsWithTZ } from "date-fns-tz";

import { cs, enUS } from "date-fns/locale";

/**
 * This composable function is used to format date and time in localised format
 * with timezone support.
 *
 * @param date Date object
 * @param formatString Format string
 * @param options Options
 *
 * @returns Localised date and time
 *
 * @example
 * const { format } = useLocalisedTzFormat();
 * const date = new Date();
 * const localisedDate = format(date, "dd.MM.yyyy HH:mm");
 */
export function useLocalisedTzFormat() {
    const { locale } = useI18n();

    const localOpt: OptionsWithTZ = {
        locale: locale.value === "cs" ? cs : enUS,
        weekStartsOn: locale.value === "cs" ? 1 : 0,
    };

    const localisedTzFormat = (
        date: Date,
        formatString: string,
        options?: OptionsWithTZ,
    ) => {
        const localisedDate = format(date, formatString, {
            ...localOpt,
            ...options,
        });
        return localisedDate;
    };

    return { format: localisedTzFormat };
}
